import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import {BrowserRouter} from "react-router-dom";
import { StyledEngineProvider } from "@mui/styled-engine";

ReactDOM.render(
    <React.Fragment>
            <BrowserRouter>
            <StyledEngineProvider injectFirst>
                <App/>
            </StyledEngineProvider>
            </BrowserRouter>
    </React.Fragment>,
    document.getElementById("root")
)
